import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    maxHeight: "100%",
    overflow: "hidden",
  },
  // Sticky header section containing title, pending indicator, navigation, and action bar
  stickyHeader: {
    position: "sticky",
    top: 0,
    zIndex: 10,
    backgroundColor: tokens.colorNeutralBackground1,
    paddingBottom: "12px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    flexShrink: 0,
  },
  // Scrollable content area
  scrollableContent: {
    flex: 1,
    overflow: "auto",
    minHeight: 0, // Important for flex overflow to work
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "40px",
  },
  positionIndicator: {
    textAlign: "center",
  },
  citationCard: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    padding: "16px",
    border: `1px solid ${tokens.colorNeutralStroke1}`,
    borderRadius: "8px",
    backgroundColor: tokens.colorNeutralBackground2,
  },
  citationHeader: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    paddingBottom: "12px",
    borderBottom: `1px solid ${tokens.colorNeutralStroke1}`,
  },
  identifier: {
    fontSize: "18px",
    fontWeight: "700",
    color: tokens.colorNeutralForeground1,
  },
  title: {
    fontSize: "14px",
    color: tokens.colorNeutralForeground2,
    fontStyle: "italic",
  },
  foundDocsSection: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  sectionTitle: {
    fontSize: "14px",
    fontWeight: "600",
    color: tokens.colorNeutralForeground1,
  },
  docItem: {
    display: "flex",
    alignItems: "stretch",
    gap: "12px",
    padding: "12px",
    border: `1px solid ${tokens.colorNeutralStroke1}`,
    borderRadius: "4px",
    backgroundColor: tokens.colorNeutralBackground1,
    cursor: "pointer",
    width: "100%",
    boxSizing: "border-box",
  },
  docItemSelected: {
    display: "flex",
    alignItems: "stretch",
    gap: "12px",
    padding: "12px",
    borderRadius: "4px",
    cursor: "pointer",
    width: "100%",
    boxSizing: "border-box",
    backgroundColor: tokens.colorBrandBackground2,
    border: `2px solid ${tokens.colorBrandStroke1}`,
  },
  docInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    flex: "1",
  },
  docTitle: {
    fontSize: "14px",
    fontWeight: "600",
    color: tokens.colorNeutralForeground1,
  },
  docMeta: {
    fontSize: "12px",
    color: tokens.colorNeutralForeground2,
  },
  navigationContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    padding: "8px 12px",
    backgroundColor: tokens.colorNeutralBackground2,
    borderRadius: "4px",
  },
  actionBar: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "24px",
    padding: "12px",
    backgroundColor: tokens.colorNeutralBackground1,
    borderRadius: "4px",
    border: `1px solid ${tokens.colorNeutralStroke1}`,
  },
  actionButton: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "4px",
    padding: "8px 16px",
    backgroundColor: "transparent",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    color: tokens.colorNeutralForeground1,
    fontSize: "12px",
    fontWeight: "500",
  },
  viewCaseButton: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "4px",
    padding: "8px 12px",
    backgroundColor: "transparent",
    border: `1px solid ${tokens.colorNeutralStroke1}`,
    borderRadius: "4px",
    cursor: "pointer",
    color: tokens.colorBrandForeground1,
    fontSize: "11px",
    fontWeight: "500",
    marginLeft: "auto",
    flexShrink: "0",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: "12px",
    paddingTop: "16px",
    borderTop: `1px solid ${tokens.colorNeutralStroke1}`,
  },
  citationList: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  citationItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px",
    border: `1px solid ${tokens.colorNeutralStroke1}`,
    borderRadius: "4px",
  },
  citationInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  actions: {
    display: "flex",
    gap: "8px",
  },
  viewCaseButtonContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "auto",
  },
});
